import React, { useState, useRef, useCallback } from 'react'

export const Tabs = ({ tabs, questionGuid, initialActiveIndex = 0 }) => {
  const [activeIndex, setActiveIndex] = useState(initialActiveIndex)
  const controlRefs = useRef([])

  const tabCount = tabs ? tabs.length : 0

  const handleKeyDown = useCallback((e, index) => {
    let target = index
    switch (e.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        e.preventDefault()
        target = (index + 1) % tabCount
        controlRefs.current[target]?.focus()
        break
      case 'ArrowLeft':
      case 'ArrowUp':
        e.preventDefault()
        target = (index - 1 + tabCount) % tabCount
        controlRefs.current[target]?.focus()
        break
      case 'Home':
        e.preventDefault()
        controlRefs.current[0]?.focus()
        break
      case 'End':
        e.preventDefault()
        controlRefs.current[tabCount - 1]?.focus()
        break
    }
  }, [tabCount])

  if (!tabCount) return null

  return (
    <div className="card-myed ml-0 mr-auto p-0 overflow-hidden w-100" style={{ maxWidth: '1000px' }}>
      <style>{`.ngn-tab-btn:focus:not(:focus-visible) { outline: none; box-shadow: none; }`}</style> {/* Helps with jerky behavior for focus events. */}
      <style>{`.myed-ngn-tab * { text-align:left}`}</style> {/* Helps align the text content inside the tabs correctly.. */}
      <div className="d-flex border-bottom" role="tablist" style={{ overflowX: 'auto' }}>
        {tabs.map((tab, i) => (
          <div key={i}>
            <button
              ref={el => { controlRefs.current[i] = el }}
              className={`btn ngn-tab-btn rounded-0 border-right py-2 px-3 mb-0${i === activeIndex ? ' btn-light btn-myed btn-primary' : ' bg-light text-secondary'}`}
              style={i !== activeIndex ? { backgroundColor: '#e9ecef' } : {}}
              role="tab"
              tabIndex={0}
              aria-selected={i === activeIndex}
              aria-controls={`tabpanel-${questionGuid}-${i}`}
              id={`tab-${questionGuid}-${i}`}
              onClick={() => setActiveIndex(i)}
              onKeyDown={e => handleKeyDown(e, i)}
            >
              {tab.name}
            </button>
          </div>
        ))}
      </div>
      {
        tabs.map((tab, i) => (
          <div
            key={i}
            className="row no-gutters"
            role="tabpanel"
            aria-labelledby={`tab-${questionGuid}-${i}`}
            id={`tabpanel-${questionGuid}-${i}`}
            tabIndex={0}
            style={{ display: i === activeIndex ? 'flex' : 'none' }}
          >
            <div
              className="col card-body p-3 m-0 myed-ngn-tab"
              dangerouslySetInnerHTML={{ __html: tab.text }}
              style={{ display: 'flow-root', textAlign: 'left', overflowX: 'auto', minWidth: 0 }}
            />
          </div>
        ))
      }
    </div >
  )
}
